import { asyncComponent } from '@wkda/after-framework';
import routesConfig from './routesConfig';

const CarleadCreationPage = asyncComponent({
  loader: () => import('./pages/CarleadCreation'),
});

const routes = routesConfig([CarleadCreationPage]);

export default routes;
